import React, { useEffect, useRef, useState } from "react";
import {
    Card,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableContainer,
    TableBody,
    CircularProgress,
    Grid,
    Paper,
} from "@mui/material";
import axios from "axios";

interface TableData {
    id_wo: string;
    status: string;
    status_pr: string;
    status_po: string;
}

export default function DashboardCardTableAutoScroll() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<TableData[]>([]);
    const containerRef = useRef<HTMLDivElement | null>(null);
    const scrollDirection = useRef<"down" | "up">("down");

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                // contoh dummy data
                const dummy: TableData[] = Array.from({ length: 40 }, (_, i) => {

                    const statusList = ["Menunggu", "Diproses", "Selesai", "Dibatalkan"];
                    const randomStatus = statusList[Math.floor(Math.random() * statusList.length)];

                    const statusPRList = ["Belum dibuat", "Dalam proses", "Terkirim ke pembelian", "Selesai"];
                    const randomStatusPR = statusPRList[Math.floor(Math.random() * statusPRList.length)];

                    const statusPOList = ["Belum dibuat", "Menunggu supplier", "Diterima sebagian", "Selesai"];
                    const randomStatusPO = statusPOList[Math.floor(Math.random() * statusPOList.length)];

                    return {
                        id_wo: `WO-${1000 + i}`,
                        status: randomStatus,
                        status_pr: randomStatusPR,
                        status_po: randomStatusPO,
                    };
                });
                setData(dummy);

            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // auto-scroll effect
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const scrollSpeed = 0.5; // kecepatan scroll
        const interval = setInterval(() => {
            if (scrollDirection.current === "down") {
                container.scrollTop += scrollSpeed;
                if (container.scrollTop + container.clientHeight >= container.scrollHeight - 1) {
                    scrollDirection.current = "up";
                }
            } else {
                container.scrollTop -= scrollSpeed;
                if (container.scrollTop <= 0) {
                    scrollDirection.current = "down";
                }
            }
        }, 20); // semakin kecil semakin halus

        return () => clearInterval(interval);
    }, [data]);

    return (
        <Card
            sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
            }}
        >
            {loading ? (
                <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}
                >
                    <CircularProgress disableShrink />
                </Grid>
            ) : (
                <TableContainer
                    component={Paper}
                    ref={containerRef}
                    sx={{
                        flex: 1,
                        borderRadius: 0,
                        overflowY: "auto",
                        scrollBehavior: "smooth",
                        height: "100%",
                    }}
                >
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>
                                    ID WO
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>
                                    Status
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>
                                    Status PR
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: 700 }}>
                                    Status PO
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {data.map((row, i) => (
                                <TableRow key={i}>
                                    <TableCell align="center">{row.id_wo}</TableCell>
                                    <TableCell align="center">{row.status}</TableCell>
                                    <TableCell align="center">{row.status_pr}</TableCell>
                                    <TableCell align="center">{row.status_po}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Card>
    );
}
